import React, { useState, useRef, useEffect } from 'react';
import ImageWithBasePath from '../../core/common/imageWithBasePath';

interface BannerProps {
    apiValues1: any;
    dest: any;
    setDesid: any
}



const Destination: React.FC<BannerProps> = ({ apiValues1, dest, setDesid }) => {

    const countries = [
        { name: 'USA', img: '/assets/flags/usa.png' },
        { name: 'Germany', img: '/assets/flags/germany.png' },
        { name: 'Australia', img: '/assets/flags/australia.png' },
        { name: 'Canada', img: '/assets/flags/canada.png' },
        { name: 'UK', img: '/assets/flags/uk.png' },
    ];

    const options = ['India', 'Aemrica', 'China', 'France'];
    const [selected, setSelected] = useState<string>('Study destination');
    const [showDropdown, setShowDropdown] = useState<boolean>(false);
    const dropdownRef = useRef<HTMLDivElement | null>(null);

    // Close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(e.target as Node)
            ) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 p-6 bg-white rounded-lg shadow-md">
            {/* Left */}
            <div className="md:w-1/2">
                <h6 className="text-lg font-semibold text-gray-800">
                    {apiValues1?.discoverText}
                </h6>
            </div>

            {/* Right */}
            <div className="md:w-1/2 w-full relative" ref={dropdownRef}>
                <div
                    className="flex items-center justify-between px-4 py-2 border rounded-lg shadow-sm bg-white cursor-pointer"
                    onClick={() => setShowDropdown(!showDropdown)}
                >
                    {/* Flags */}
                    {/* <div className="flex -space-x-2">
                        {countries.map((country, index) => (
                            <img
                                key={index}
                                src={country.img}
                                alt={country.name}
                                className="w-6 h-6 rounded-full border border-white object-cover"
                            />
                        ))}
                    </div> */}

                    <div className="community-count p-2">
                        <div className="enrolled-list">
                            <div className="avatar-list-stacked mb-2">

                                {/* {dest?.map((option: any, index: number) => ( */}
                                {
                                    (Array.isArray(dest) ? dest : []).map((option: any, index: number) => {

                                        return (
                                            <span className="avatar avatar-rounded">
                                                <ImageWithBasePath
                                                    className="border border-white"
                                                    source={option?.countryImage}
                                                    alt="img"
                                                />
                                            </span>
                                        )

                                    }) || []

                                }


                            </div>
                        </div>
                    </div>

                    {/* Selected Label */}
                    <span className="text-sm text-gray-700 ml-3 flex-1 truncate">{selected}</span>

                    {/* Dropdown Icon */}
                    <svg
                        className={`w-4 h-4 text-gray-500 transform transition-transform duration-200 ${showDropdown ? 'rotate-180' : ''
                            }`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                    </svg>
                </div>

                {/* Dropdown Options */}
                {showDropdown && (
                    <div className="absolute mt-1 w-full bg-white border rounded-md shadow z-10">
                        {dest?.map((option: any, index: number) => (
                            <div
                                key={index}
                                className="px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer"
                                onClick={() => {
                                    setSelected(option?.countryName);
                                    setShowDropdown(false);
                                    setDesid(option._id)
                                }}
                            >
                                <div className='flex items-center gap-1'>

                                    <span className="avatar ">
                                        <ImageWithBasePath
                                         style={{ width: 32, height: 20 }}
                                            className="border border-white h-5 w-8"
                                            source={option?.countryImage}
                                            alt="img"
                                        />
                                    </span>

                                    {option?.countryName}

                                </div>

                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Destination;
